import React from 'react';
import { Switch, Route } from 'react-router-dom';
import AuthRoute from '../../utils/authRoute';
import DesignForm from '../../pages/design/detail/designForm.js';
import TemplateForm from '../../pages/design/detail/templateForm';
import PageError from '../../pages/error/pageError';
import List from '../../pages/design/list/list.js';

export default function TicketsDesignRouter({ organization, path }) {
    return (
        <Switch>
            <AuthRoute
                exact
                path={`${path}/designs/`}
                allow={['PyvarCapacity.DESIGN', 'PyvarCapacity.DESIGN_ADMIN']}
                render={({ match, history }) => {
                    return <List organization={organization} activeTab={0} />;
                }}
            />
            <AuthRoute
                exact
                path={`${path}/designs/new/`}
                allow={['PyvarCapacity.DESIGN', 'PyvarCapacity.DESIGN_ADMIN']}
                render={({ match, history }) => {
                    return <DesignForm organization={organization} />;
                }}
            />
            <AuthRoute
                exact
                path={`${path}/designs/:designId`}
                allow={['PyvarCapacity.DESIGN', 'PyvarCapacity.DESIGN_ADMIN']}
                render={({ match, history }) => {
                    return <DesignForm organization={organization} designId={match.params.designId} />;
                }}
            />
            <AuthRoute
                exact
                path={`${path}/templates`}
                allow={['PyvarCapacity.DESIGN_ADMIN', 'PyvarCapacity.DESIGN_TEMPLATES']}
                render={({ match, history }) => {
                    return <List organization={organization} activeTab={1} />;
                }}
            />
            <AuthRoute
                exact
                path={`${path}/templates/new`}
                allow={['PyvarCapacity.DESIGN_ADMIN', 'PyvarCapacity.DESIGN_TEMPLATES']}
                render={({ match, history }) => {
                    return <TemplateForm organization={organization} />;
                }}
            />
            <AuthRoute
                exact
                path={`${path}/templates/:templateId`}
                allow={['PyvarCapacity.DESIGN_ADMIN', 'PyvarCapacity.DESIGN_TEMPLATES']}
                render={({ match, history }) => {
                    return <TemplateForm organization={organization} templateId={match.params.templateId} />;
                }}
            />
            <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
        </Switch>
    );
}
